export const GET_WELCOME = "GET_WELCOME";
export const GET_STATE_LOADING = "GET_STATE_LOADING";